import { Component, OnInit, Inject } from '@angular/core';
import {
  MatTableDataSource, MatDatepickerInputEvent,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import { Router } from '@angular/router';
import { TripService } from '../../services/trip/trip.service';
import { OrderService } from '../../services/order/order.service';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it' }, //you can change useValue
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class AdminComponent implements OnInit {
  columnsToDisplay = [
    'invoice',
    'dispatchDate',
    'receiverDetails',
    'status',
    'action',
    'delete',
  ];
  orderDataArray = new MatTableDataSource;
  page: number = 0;
  totalRecords: number;
  dispatchDate: string;
  minDate: Date;
  unplannedcount: number = 0;
  onholdcount: number = 0;
  intransitcount: number = 0;
  scheduledcount: number = 0;
  failedcount: number = 0;
  nostockcount: number = 0;
  orderDataArrayForCheck = [];
  selectedOrdersDataArray: Array<any> = [];
  selectedForDelete = [];
  protected ngUnsubscribe: Subject<void> = new Subject<void>();



  postSNResponse;
  postSNRes;
  fromDate: any;
  toDate: any;
  isLoading: boolean = false;
  deleteSpinner: boolean = false;
  isAllSelected: boolean;
  isPageAllSelected = [];

  constructor(public orderService: OrderService,
    public router: Router,
    public dialog: MatDialog,
    public tripService: TripService,
    public datePipe: DatePipe,
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    let date, last, day, month, year;
    date = new Date();
    //7 is num of days
    last = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000));
    day = last.getDate();
    month = last.getMonth();
    year = last.getFullYear();
    this.fromDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.postSNRes = localStorage.getItem(this.postSNResponse);;
    this.minDate = new Date();
    this.getTotalCount();

    this.getData('ORDER_STATE_UNPLANNED', 'ORDER_STATE_ON_HOLD', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_FAILED', 'ORDER_STATE_NO_STOCK').subscribe(allOrders => {
      let allO = allOrders;
      allO.forEach(function (obj) { obj.isChecked = false });
      this.isLoading = false;
      this.orderDataArray.data = allOrders;
      this.orderDataArrayForCheck = allO;
      for (let i = 0; i < allOrders.totalPages; i++) {
        this.isPageAllSelected.push(0);
      }
      console.log("data", this.orderDataArray.data);
    });
  }

getTotalCount(){
  this.orderService.getOrderCountByStatus(this.fromDate, this.toDate, ['ORDER_TYPE_DELIVERY', 'ORDER_TYPE_PICKUP', 'ORDER_TYPE_MARKETING_VISIT', 'ORDER_TYPE_STORE_PICKUP', 'ORDER_TYPE_HOME_COLLECTION']).subscribe(res => {
    console.log("getOrderCountByStatus", res);
    if (this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED') != undefined) {
      this.unplannedcount = this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED').ordercount;
    }
    if (this.searchArraryForCount(res, 'ORDER_STATE_ON_HOLD') != undefined) {
      this.onholdcount = this.searchArraryForCount(res, 'ORDER_STATE_ON_HOLD').ordercount;
    }
    if (this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT') != undefined) {
      this.intransitcount = this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT').ordercount;
    }

    if (this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED') != undefined) {
      this.scheduledcount = this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED').ordercount;
    }
    if (this.searchArraryForCount(res, 'ORDER_STATE_FAILED') != undefined) {
      this.failedcount = this.searchArraryForCount(res, 'ORDER_STATE_FAILED').ordercount;
    }
    if (this.searchArraryForCount(res, 'ORDER_STATE_NO_STOCK') != undefined) {
      this.nostockcount = this.searchArraryForCount(res, 'ORDER_STATE_NO_STOCK').ordercount;
    }
    this.totalRecords = this.nostockcount + this.unplannedcount + this.onholdcount + this.intransitcount + this.scheduledcount + this.failedcount + this.nostockcount;

    console.log("totalRecords", this.totalRecords);
  });
}

  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].orderstatus === value) {
        return arr[i];
      }
    }
  }

  getData(type1, type2, type3, type4, type5, type6) {
    let types = [];
    types.push(type1, type2, type3, type4, type5, type6);
    return this.orderService.getAllOrdersByTypes(types, this.page);
  }



  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  expandedElement: any;

  HoldOrder(order) {
    order.orderInfo.oState = "ORDER_STATE_ON_HOLD";
    this.orderService.orderStateChange(order.orderInfo.orderUniqueId, order.orderInfo.oState).subscribe(() => {
      alert("order" + " " + order.orderInfo.orderUniqueId + " " + "is moved on hold");
    }, Error => {
      console.log(Error);
    });
  }

  openConfirmation(changedvalue, order, remarks) {
    console.log("remarks", remarks);
    const dialogRef = this.dialog.open(ChangeStatusDialogConfirm, {
      width: '300px',
      data: changedvalue
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        if (changedvalue == 'onhold') {
          this.HoldOrder(order);
        }
        else if (changedvalue == 'markdelivered') {
          this.orderService.adminDeliverOrder(order.orderInfo.orderUniqueId).subscribe(() => {
            console.log(order.orderInfo.orderUniqueId + "order is delivered");
          }, Error => {
            console.log(Error);
          });
        }
        else if (changedvalue == 'rescheduledelivery') {
          this.orderService.adminRescheduleDelivery(order).subscribe(() => {
            console.log(order.orderInfo.orderUniqueId + "order is rescheduled for delivery.");
          }, Error => {
            console.log(Error);
          });
        }
      }
    });
  }

  deleteOrderConfirm() {
    const delOrder = this.dialog.open(DeleteOrderConfirm, {
      width: '300px',
    });

    delOrder.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        {
          this.OnOrderDelete(this.selectedOrdersDataArray);
        }
      }
    });
  }


  OnOrderDelete(selected) {
    console.log("selected", selected);
    this.deleteSpinner = true;
    this.orderService.deleteOrder(selected).subscribe(res => {
      this.deleteSpinner = false;
      console.log("Order Deleted " , res);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/admin"]));
    }, Error => {
      console.log(Error);
    });


  }

  pageChanged(event) {
    this.ngUnsubscribe.next();
    this.isLoading = true;
    this.page = event.pageIndex;
    if (this.isPageAllSelected[this.page] == true) {
      this.isAllSelected = true;
    }
    else
      this.isAllSelected = false;
    this.orderDataArray.data = [];
    this.getData('ORDER_STATE_UNPLANNED', 'ORDER_STATE_ON_HOLD', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_FAILED', 'ORDER_STATE_NO_STOCK').pipe(takeUntil(this.ngUnsubscribe)).subscribe(allOrders => {
      let allO = allOrders;
      allO.forEach(function (obj) { obj.isChecked = false });
      let selOrder = this.selectedOrdersDataArray;
      console.log(this.selectedOrdersDataArray);
      this.orderDataArrayForCheck = allO;

      /*this filters selected orders that is ticked orders so that when user
       clicks next or prev button the selected order won't loss*/
      this.orderDataArrayForCheck.filter(r => {
        selOrder.forEach(l => {
          if (l.orderUniqueId === r.orderInfo.orderUniqueId) {
            r.isChecked = true;
          }
        });
      });
      this.isLoading = false;
      this.orderDataArray.data = allO;
      console.log("data", this.orderDataArray.data)
    });

  }

  
  selectAll(event) {
    if (event.checked) {
      this.isPageAllSelected[this.page] = true;
      this.isAllSelected = true;
      this.orderDataArrayForCheck.forEach(function (obj) {
        if (obj.orderInfo.oState == 'ORDER_STATE_UNPLANNED')
          obj.isChecked = true;
        else
          obj.isChecked = false;
      });
      this.orderDataArray.data = this.orderDataArrayForCheck;
      this.orderDataArrayForCheck.forEach(order => {
        if (order.orderInfo.oState == 'ORDER_STATE_UNPLANNED') {
          //skip order if already exist
          let isOrderExistIndex = this.selectedOrdersDataArray.findIndex(i => i.orderUniqueId == order.orderInfo.orderUniqueId);
          if (isOrderExistIndex == -1) {
            this.selectedOrdersDataArray.push(order.orderInfo);
          }
        }

      });
    }
    else {
      this.isPageAllSelected[this.page] = false;
      this.isAllSelected = false;
      this.orderDataArrayForCheck.forEach(function (obj) { obj.isChecked = false; });

      //remove unselected orders from already selected orders
      this.orderDataArrayForCheck.forEach(order => {
        let removeIndex = this.selectedOrdersDataArray.findIndex(i => i.orderUniqueId == order.orderInfo.orderUniqueId);
        this.selectedOrdersDataArray.splice(removeIndex, 1);
      });
      this.orderDataArray.data = this.orderDataArrayForCheck;
    }
    console.log("Selected Orders", this.selectedOrdersDataArray)
  }


  selOrders(productchecked, Event) {
    console.log("picked product ", productchecked)

    if (Event.checked) {
      productchecked.bMarkForDelivery = true;
    } else {
      productchecked.bMarkForDelivery = false;
    }
  }

  onToggleChange() {
    this.tripService.togglePostSN().subscribe(postSN => {
      console.log("result of postSN", postSN);
      localStorage.setItem(this.postSNResponse, postSN);
    },
      Error => {
        console.log(Error);
      });
  }

  addToDelete(order, Event) {
    let oid = order.orderInfo.orderUniqueId;
    let foundOrder = this.orderDataArrayForCheck.find(pl => pl.orderInfo.orderUniqueId === oid);
    if (Event.checked) {
      let index = this.orderDataArrayForCheck.indexOf(foundOrder);
      this.orderDataArrayForCheck[index].isChecked = true;
      this.selectedOrdersDataArray.push(order.orderInfo);
    } else if (!Event.checked) {
      if (this.isPageAllSelected[this.page] == true) {
        this.isAllSelected = false;
        this.isPageAllSelected[this.page] = false;
      }
      let index = this.orderDataArrayForCheck.indexOf(foundOrder);
      let removeIndex = this.selectedOrdersDataArray.findIndex(i => i.orderUniqueId == order.orderInfo.orderUniqueId);
      this.orderDataArrayForCheck[index].isChecked = false;
      this.selectedOrdersDataArray.splice(removeIndex, 1);
    }
    this.orderDataArray.data = this.orderDataArrayForCheck;
    this.checkAllOrdersAreAlreadySelectedFromFilter();
    console.log("Selected Orders", this.selectedOrdersDataArray)
  }

  //this function checks whether All orders from seleced filter are already selected
  checkAllOrdersAreAlreadySelectedFromFilter() {
    for (let i = 0; i < this.orderDataArrayForCheck.length; i++) {
      let findOrder = this.selectedOrdersDataArray.findIndex(sel => sel.orderUniqueId === this.orderDataArrayForCheck[i].orderInfo.orderUniqueId);
      if (findOrder == -1) {
        this.isAllSelected = false;
        this.isPageAllSelected[this.page] = false;
        break;
      }
      else {
        this.isAllSelected = true;
        this.isPageAllSelected[this.page] = true;
      }
    }
  }

  deliveryDateChange(event: MatDatepickerInputEvent<Date>, order) {
    console.log(order,new Date(event.value));
    const dialogRef = this.dialog.open(ChangeStatusDialogConfirm, {
      width: '300px',
      data: 'dateChange'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        let date;
        date = this.datePipe.transform(new Date(event.value), 'yyyy-MM-dd') + 'T00:00:00'
        order.orderInfo.deliveryETADateTime = date;
        console.log(order);
        this.orderService.orderUpdate(order).subscribe(res => {
          console.log(res);
        }, Error => {
          console.log(Error);
        });
      }
    });
  }
}




@Component({
  selector: 'dialog-confirm',
  template: `
  <div style="padding:20px;">
  <div *ngIf = "data==='dateChange'; else othervalue">
  <p> Are you sure you want to change delivery date?</p>
  </div>
  <ng-template #othervalue>
    <p> Are you sure you want to move this order to <span>{{data}}</span></p>
    </ng-template>
    <div class="row">
    <div class="col">
       <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes</button>
     </div>
      <div class="col">
        <button mat-raised-button color="warn" (click)="onNoClick()">No</button>
      </div>
    </div>
  </div>
  `,
})
export class ChangeStatusDialogConfirm {
  value: string;

  constructor(
    public dialogRef: MatDialogRef<ChangeStatusDialogConfirm>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.data = data;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'dialog-order-confirm',
  template: `
  <div style="padding:20px;">
    <p> Are you sure you want to delete orders</p>
    <div class="row">
    <div class="col">
       <button mat-raised-button color="primary" [mat-dialog-close]="true">Yes</button>
     </div>
      <div class="col">
        <button mat-raised-button color="warn" (click)="onNoClick()">No</button>
      </div>
    </div>
  </div>
  `,
})


export class DeleteOrderConfirm {
  constructor(
    public delOrder: MatDialogRef<DeleteOrderConfirm>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onNoClick(): void {
    this.delOrder.close();
  }
}



